import gql from "graphql-tag"
import { useMutation } from "react-apollo"
import { CdnVendor } from "@modules/graphql/types"
import { useCreateIntegration } from "../../shared/hooks/useCreateIntegration"

export const CREATE_VERCEL_PROJECT_MUTATION = gql`
  mutation createNowProjet(
    $siteId: UUID!
    $serviceName: String!
    $accountName: String
  ) {
    createNowProject(
      siteId: $siteId
      serviceName: $serviceName
      accountName: $accountName
    ) {
      validation {
        success
        message
      }
      nowProject {
        id
        name
      }
    }
  }
`

export const useCreateVercelIntegration = (onSuccess, setError) => {
  const [
    createIntegration,
    { loading: loadingIntegration },
  ] = useCreateIntegration(CdnVendor.Now)
  const [createVercelIntegrationMutation, { loading, error }] = useMutation(
    CREATE_VERCEL_PROJECT_MUTATION
  )

  const createVercelIntegration = async (projectName, siteId, teamId) => {
    try {
      const { data } = await createVercelIntegrationMutation({
        variables: {
          siteId,
          serviceName: projectName,
          accountName: teamId,
        },
      })
      if (!data.createNowProject.validation.success) {
        setError({ message: data.createNowProject.validation.message })
      }

      const { data: integrationData } = await createIntegration(
        siteId,
        data.createNowProject.nowProject.id,
        projectName,
        teamId
      )

      return onSuccess({
        success: integrationData.setCDNConfig.success,
        errorType: integrationData.setCDNConfig.errorType,
      })
    } catch (e) {
      setError(e)
    }
  }

  return [
    createVercelIntegration,
    { error, loading: loading || loadingIntegration },
  ]
}
